import React, { useEffect, useState } from 'react';
import { getKategoriesDataAPI } from '../../API/kategories';
import {
    fetchAiTags,
    fetchAnnotationRuleset, updateAnnotationRuleset
} from '../../API/annotatorApi';
import { Modal, Button, ButtonGroup, Row, Col, Form } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import Loader from 'react-loader-advanced';
import Oval from 'react-loader-spinner';
import '../../Styles/Annotator/AnnotationRuleset.css';


function filterObject(obj, searchString) {

    if (searchString.trim() === "") {
        return obj;
    }

    const filteredObj = {};
    const lowerSearch = searchString.toLowerCase();

    for (const [key, value] of Object.entries(obj)) {
        const keyMatches = key.toLowerCase().includes(lowerSearch);
        const valueMatches = value["ai_tags"].some(str => str.toLowerCase().includes(lowerSearch));
        if (keyMatches || valueMatches) {
            filteredObj[key] = value;
        }
    }

    return filteredObj;
}


function AnnotationRulesetModal(props) {

    if (!props.show) {
        return null;
    }

    const [categories, setCategories] = useState([]);
    const [selectedAiTags, setSelectedAiTags] = useState([]);
    const [aiTags, setAiTags] = useState([]);
    const [ruleset, setRuleset] = useState({});
    const [selectedCategory, setSelectedCategory] = useState('');
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);

    // const [showEditCatUnits, setShowEditCatUnits] = useState(false);
    // const [risksItem, setRisksItem] = useState(null);
    //
    // const handleEditCatUnitsModalClose = () => {
    //     setShowEditCatUnits(false);
    //     setRisksItem(null);
    // }
    // const handleChildModalShow = (item) => {
    //     alert(item);
    // }

    const filteredData = filterObject(ruleset, searchTerm);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const toggleStateChange = async (key) => {
        ruleset[key]["active"] = !ruleset[key]["active"];
        setRuleset({...ruleset});
        await updateAnnotationRuleset(ruleset);
    }

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(Object.keys(filteredData).length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentKeys = Object.keys(filteredData).slice(indexOfFirstItem, indexOfLastItem);

    const renderItems = currentKeys.map((key, index) => (
        <tr key={index}>
            <td>
                <input type="checkbox" key={index}
                       checked={ruleset[key]["active"]}
                       onChange={() => toggleStateChange(key)}
                       style={{ verticalAlign: 'middle' }} />
            </td>
            <td>{key}</td>
            <td>{ruleset[key]['ai_tags'].join(', ')}</td>
            <td>
                <ButtonGroup>
                    {/*<Button size="sm" style={{ margin: '0 2px' }}*/}
                    {/*        onClick={() => handleChildModalShow(key)}>Edit</Button>*/}
                    <Button size="sm" style={{ margin: '0 2px' }}
                            onClick={() => handleRemoveRule(key)}>Delete</Button>
                </ButtonGroup>
            </td>
        </tr>
    ));

    useEffect(() => {
        if (props.show) {
            const fetchData = async () => {
                try {
                    setLoading(true);

                    const [categories, aiTags, ruleset] =
                        await Promise.all([getKategoriesDataAPI(), fetchAiTags(), fetchAnnotationRuleset()]);

                    setCategories(categories.map(cat => cat["category"]).sort());
                    setAiTags(aiTags["response"].filter(tag => !tag.startsWith("ATV")));
                    setRuleset(ruleset["response"]);
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [props.show]);

    if (!props.show) {
        return null;
    }

    const handleCategorySelect = (e) => {
        let category = e.target.value.replace(/(<([^>]+)>)/ig, '');
        setSelectedCategory(category);
    }

    const resetState = () => {
        setSelectedCategory("");
        setSelectedAiTags([]);
    }

    const handleOnHide = () => {
        props.onHide();
        resetState();
    }

    const validateForm = () => {
        return !(selectedCategory !== "" && selectedAiTags.length > 0);
    }

    const handleAddAnnotationRule = async () => {
        setLoading(true);
        let newRule = {[selectedCategory]: {"ai_tags": selectedAiTags, "active": true}}
        let updatedRulesetMap = {...ruleset, ...newRule}
        const updated_ruleset = await updateAnnotationRuleset(updatedRulesetMap);
        setRuleset(updated_ruleset.response);
        setLoading(false);
        resetState();
    }

    const handleRemoveRule = async (key) => {
        setLoading(true);
        delete ruleset[key];
        const updated_stats = await updateAnnotationRuleset(ruleset);
        setRuleset(updated_stats.response);
        setLoading(false);
    }

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    // const EditAttributeRulesetModal = ({risksItem}) => {
    //     if (risksItem == null || !('units' in risksItem)) {
    //         return null;
    //     }
    //     const [name, setName] = useState(risksItem.name);
    //     const [description, setDescription] = useState(risksItem.description);
    //     const [units, setUnits] = useState(risksItem.units);
    //
    //     useEffect(() => {
    //         setName(risksItem.name);
    //         setDescription(risksItem.description);
    //         setUnits(risksItem.units);
    //     }, [risksItem]);
    //
    //     const isFormInvalid = () => {
    //         return name.trim() === '' || units.length === 0;
    //     }
    //
    //     const handleSaveCatUnitsChanges = async () => {
    //         const updatedItem = { ...risksItem, name, description, units };
    //         const updated_stats = await updateCategoryUnits(updatedItem);
    //         handleEditCatUnitsModalClose();
    //         setLoading(true);
    //         setRuleset(updated_stats.response);
    //         setLoading(false);
    //     }
    //
    //     return (
    //         <Modal show={showEditCatUnits} dialogClassName="ruleset-child-modal" onHide={handleEditCatUnitsModalClose}
    //                 aria-labelledby="contained-modal-title-vcenter" centered>
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Edit {name}</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body className="ruleset-child-modal-body">
    //                 {
    //                     <>
    //                         <h6>Name</h6>
    //                         <div>
    //                             <input type="text" className="ruleset-child-modal-input" value={name}
    //                                    onChange={(e) => {
    //                                        setName(e.target.value);
    //                                    }} />
    //                         </div>
    //                         <br />
    //                         <h6>Description</h6>
    //                         <div>
    //                             <input type="text" className="ruleset-child-modal-input" value={description}
    //                                    onChange={(e) => {
    //                                        setDescription(e.target.value);
    //                                    }}
    //                                    placeholder="Description" />
    //                         </div>
    //                         <br />
    //                         <h6>Einheiten</h6>
    //                         <div className="einheit-child-modal">
    //                             <Multiselect
    //                                 placeholder={'Einheit'}
    //                                 isObject={false}
    //                                 options={['St', 'm', 'm2', 'm3', 'cm', 'cm2', 'psch', 'pau', 'h', 'd', 'Wo', 'Mt', 'a', 'kg', 't', 'l']}
    //                                 onSelect={(selectedList, selectedItem) => {
    //                                     units.push(selectedItem);
    //                                     setUnits([...units]);
    //                                 }}
    //                                 onRemove={(selectedList, removeItem) => {
    //                                     let unitsFiltered = units.filter((el) => el !== removeItem);
    //                                     setUnits([...unitsFiltered]);
    //                                 }}
    //                                 avoidHighlightFirstOption={true}
    //                                 selectedValues={units}
    //                                 showCheckbox
    //                             />
    //                         </div>
    //                     </>
    //                 }
    //             </Modal.Body>
    //             <Modal.Footer>
    //                 <ButtonGroup>
    //                     <Button variant="primary" style={{ margin: '0 2px' }}
    //                             disabled={isFormInvalid()}
    //                             onClick={handleSaveCatUnitsChanges}>
    //                         Save
    //                     </Button>
    //                 </ButtonGroup>
    //             </Modal.Footer>
    //         </Modal>
    //     );
    // }

    return (
        <>
            <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton onHide={handleOnHide}>
                    <Modal.Title>Annotations Ruleset</Modal.Title>
                </Modal.Header>
                <Modal.Body className="ruleset-wider-modal-body">
                    {
                        <>
                            <div className="search-container">
                                <input
                                    className="ruleset-search-input"
                                    type="text"
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    placeholder="Search in annotations ruleset"
                                />
                            </div>
                            <Loader show={loading} message={<span>
                            <Oval
                                visible={true}
                                height="50"
                                width="50"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                type="Oval" /></span>}>
                                <table className="ruleset-table">
                                    <thead>
                                    <tr>
                                        <th>Active</th>
                                        <th>Category</th>
                                        <th>AI-Tags</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>{renderItems}</tbody>
                                </table>
                            </Loader>

                            <div className="ruleset-pagination-container">
                                <ul className="ruleset-pagination">
                                    {pageNumbers.map((number) => (
                                        <li key={number}>
                                            <button
                                                className={`ruleset-pagination-button ${currentPage === number ? 'active' : ''}`}
                                                onClick={() => handlePageChange(number)}
                                            >
                                                {number}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Row>
                                <Col sm="3">
                                    <Form.Group>
                                        <Form.Control as="select" value={selectedCategory}
                                                      onChange={handleCategorySelect} style={{width: "190px"}}>
                                            <option value="">Select Category</option>
                                            {
                                                categories.map((cat, index) => (
                                                    <option value={cat} key={index}>{cat}</option>
                                                ))
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm="8">
                                    <div className="ai-tags">
                                         <Multiselect
                                            placeholder={'AI-Tags'}
                                            isObject={false}
                                            options={aiTags}
                                            onSelect={(selectedList, selectedItem) => {
                                                selectedAiTags.push(selectedItem);
                                                setSelectedAiTags([...selectedAiTags]);
                                            }}
                                            onRemove={(selectedList, removeItem) => {
                                                let selectedEinheitsFiltered = selectedAiTags.filter((el) => el !== removeItem);
                                                setSelectedAiTags([...selectedEinheitsFiltered]);
                                            }}
                                            avoidHighlightFirstOption={true}
                                            selectedValues={selectedAiTags}
                                            showCheckbox
                                        />
                                    </div>
                                </Col>
                                <Col sm="1" style={{padding: "0px"}}>
                                    <Button variant="primary" type="button"
                                            onClick={handleAddAnnotationRule}
                                            disabled={validateForm()}>Add</Button>
                                </Col>
                            </Row>
                        </>
                    }
                </Modal.Body>
            </Modal>
            {/*<EditAttributeRulesetModal risksItem={risksItem}/>*/}
        </>
    );
}

export default AnnotationRulesetModal;